module.exports = __webpack_public_path__ + "img/phonebg.7c16fe29.png";